import Select from "react-select";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";

/* MATERIAL TAILWIND COMPONENTS */
import { Button } from "@material-tailwind/react";

/* ICONS */
import { IoIosCall } from "react-icons/io";
import { MdEmail } from "react-icons/md";
import { FormInput, PhoneInputField } from "../../components/core/input";

/* CONTAINER ANIMATION */
const containerAnimation = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.12, delayChildren: 1 },
  },
};

/* DIV ANIMATION */
const animation = {
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      damping: 12,
      delay: 1,
      stiffness: 100,
    },
  },
  hidden: {
    opacity: 0,
    y: 20,
    transition: {
      type: "spring",
      damping: 12,
      delay: 1,
      stiffness: 100,
    },
  },
};

/* SUBJECT OPTIONS */
const subjectOptions = [
  {
    label: "General Inquiry",
    value: "General Inquiry",
  },
  {
    label: "Product Inquiry",
    value: "Product Inquiry",
  },
  {
    label: "Returns & Exchanges",
    value: "Returns & Exchanges",
  },
  {
    label: "Feedback & Suggestions",
    value: "Feedback & Suggestions",
  },
  {
    label: "Media & Press Inquiries",
    value: "Media & Press Inquiries",
  },
];

const ContactUs = () => {
  return (
    <motion.section
      variants={containerAnimation}
      initial="hidden"
      animate="visible"
      className="bg-white"
    >
      {/* HELMET */}
      <Helmet>
        <title>Contact Us | Food Farmacy</title>
      </Helmet>

      <motion.div variants={animation} className="p-5">
        <div className="container-full-width">
          <div className="grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-5 xl:gap-10 lg:gap-10 items-center">
            {/* APPOINTMENT FORM */}
            <div className="col-span-1">
              <div className="container !p-0 xl:!p-5 lg:!p-5">
                <div className="ml-0 xl:ml-[17.5vh] lg:ml-[17.5vh]">
                  <h1 className="text-3xl xl:text-4xl lg:text-4xl font-source font-extrabold text-black tracking-tight leading-tight xl:leading-tight lg:leading-tight">
                    SCHEDULE APPOINTMENT WITH OUR EXPERT{" "}
                    <span className="text-logoOrange">FOOD FARMACY</span>{" "}
                    <span className="text-logoPurple">TEAM</span>
                  </h1>
                  <h2 className="text-lg font-source font-normal text-greyText tracking-tight mt-5">
                    Contact us today for expert guidance in knowing more about
                    the products that we provide and how they can help you
                    achieve your health and wellness goals.
                  </h2>
                  <div className="grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-5 mt-5">
                    <div className="col-span-1 w-full bg-primaryRed bg-opacity-5 border border-primaryRed p-5 rounded-xl">
                      <IoIosCall className="w-9 h-9 text-logoRed" />
                      <h5 className="mt-3 text-black font-source font-semibold text-base">
                        Call us on Mon-Fri
                      </h5>
                      <a
                        href="tel:+918792795765"
                        className="block text-xl font-source font-bold text-black mt-1 hover:text-logoRed"
                      >
                        +91 8792795765
                      </a>
                    </div>
                    <div className="col-span-1 w-full bg-primaryRed bg-opacity-5 border border-primaryRed p-5 rounded-xl">
                      <MdEmail className="w-9 h-9 text-logoRed" />
                      <h5 className="mt-3 text-black font-source font-semibold text-base">
                        Email us at
                      </h5>
                      <a
                        href="mailto:info@foodfarmacy.com"
                        className="block text-xl font-source font-bold text-black mt-1 hover:text-logoRed"
                      >
                        info@foodfarmacy.com
                      </a>
                    </div>
                  </div>
                  <form className="rounded-xl bg-primaryRed bg-opacity-5 border border-primaryRed p-5 xl:p-10 lg:p-10 mt-5">
                    <div className="block xl:flex lg:flex items-center gap-5">
                      <div className="form-group w-full">
                        <label className="text-base font-source font-semibold text-black">
                          Name <span className="text-red-500">*</span>
                        </label>
                        <div className="mt-1">
                          <FormInput
                            type="text"
                            name="name"
                            id="name"
                            placeholder="Name"
                          />
                        </div>
                      </div>
                      <div className="form-group w-full mt-5 xl:mt-0 lg:mt-0">
                        <label className="text-base font-source font-semibold text-black">
                          Email address <span className="text-red-500">*</span>
                        </label>
                        <div className="mt-1">
                          <FormInput
                            type="email"
                            name="email"
                            id="email"
                            placeholder="Email address"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="block xl:flex lg:flex items-center gap-5 mt-5">
                      <div className="form-group w-full mt-5 xl:mt-0 lg:mt-0">
                        <label className="text-base font-source font-semibold text-black">
                          Phone <span className="text-red-500">*</span>
                        </label>
                        <div className="mt-1">
                          <PhoneInputField />
                        </div>
                      </div>
                      <div className="form-group w-full mt-5 xl:mt-0 lg:mt-0">
                        <label className="text-base font-source font-semibold text-black">
                          Subject <span className="text-red-500">*</span>
                        </label>
                        <div className="mt-1">
                          <Select
                            options={subjectOptions}
                            className="react-select"
                            classNamePrefix="state"
                            placeholder="Subject"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group mt-5">
                      <label className="text-base font-source font-semibold text-black">
                        Message <span className="text-red-500">*</span>
                      </label>
                      <div className="mt-1">
                        <textarea
                          rows={3}
                          className="w-full block border border-[#E5E5E5] rounded mt-1 px-4 py-2 font-source font-semibold placeholder:font-source placeholder:font-normal text-base placeholder:text-sm"
                          placeholder="Write your message"
                          name="message"
                        />
                      </div>
                    </div>
                    <Button className="mt-5 shadow-none hover:shadow-none text-base text-white bg-primaryRed normal-case font-source font-semibold font-normal rounded py-2">
                      Submit details
                    </Button>
                  </form>
                </div>
              </div>
            </div>

            {/* LOCATION DETAILS */}
            <div className="col-span-1">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14684.850590210415!2d72.5376706!3d23.0526643!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e85727042f0bb%3A0xabf3b8ec68a88196!2sFood%20Farmacy!5e0!3m2!1sen!2sin!4v1710330386875!5m2!1sen!2sin"
                className="w-full h-[40vh] xl:h-[88vh] lg:h-[88vh] border border-[#E5E5E5] rounded-lg shadow-xl"
                title="Clinic Address"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </motion.div>
    </motion.section>
  );
};

export default ContactUs;
